module.exports = __webpack_public_path__ + "d80091ac0878a4fac0fa96f1db0ad61e.png";